import * as types from '../services/scheduleViewerActionType';

const today = new Date();
const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
const twelveMonthsOut = new Date(today.getFullYear() + 1, today.getMonth() + 1, 0).toISOString().split('T')[0];

const initialState = {
    filters: {
        fromDate: firstOfMonth,
        toDate: twelveMonthsOut,
        radIds: '',
        workListIds: '',
        siteIds: '',
        stateIds: '',
        practiceMode: null,
        includeQgenda: true,
        includeUserCreated: true,
        includeGenerated: true,
    },
    view: 'month',
    shifts: {
        loading: false,
        data: [],
        error: null,
        lastFetchParams: null,
    },
    selectedShift: {
        open: false,
        mode: 'view',
        data: null,
        groupScope: null,
        groupPeopleScope: null,
    },
    dropdowns: {
        loading: false,
        radiologists: [],
        worklists: [],
        sites: [],
        states: [],
        tasks: [],
    },
    shiftForm: {
        saving: false,
        deleting: false,
        updatingNotes: false,
        privileges: [],
        privilegesLoading: false,
        radAssociatedSites: [],
        radAssociatedSitesLoading: false,
        radAssociatedSitesByRad: {},
        radsAssociatedSitesLoading: false,
        bulkSaving: false,
        bulkResult: null,
        groupActionLoading: false,
        conflictPreview: null,
    },
};

const scheduleViewerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_SHIFTS_REQUEST:
            return {
                ...state,
                shifts: { ...state.shifts, loading: true, error: null, lastFetchParams: action.payload },
            };
        case types.FETCH_SHIFTS_SUCCESS:
            return { ...state, shifts: { ...state.shifts, loading: false, data: action.payload, error: null } };
        case types.FETCH_SHIFTS_FAILURE:
            return { ...state, shifts: { ...state.shifts, loading: false, error: action.payload } };

        case types.SET_SCHEDULE_VIEW:
            return { ...state, view: action.payload };

        case types.SET_SCHEDULE_FILTERS:
            return { ...state, filters: { ...state.filters, ...action.payload } };

        case types.SET_SELECTED_SHIFT:
            return {
                ...state,
                selectedShift: {
                    open: true,
                    mode: action.payload.mode || 'view',
                    data: action.payload.data,
                    groupScope: action.payload.groupScope || null,
                    groupPeopleScope: action.payload.groupPeopleScope || null,
                },
            };
        case types.CLEAR_SELECTED_SHIFT:
            return { ...state, selectedShift: { open: false, mode: 'view', data: null, groupScope: null, groupPeopleScope: null } };

        case types.FETCH_SCHEDULE_DROPDOWNS_REQUEST:
            return { ...state, dropdowns: { ...state.dropdowns, loading: true } };
        case types.FETCH_SCHEDULE_DROPDOWNS_SUCCESS:
            return { ...state, dropdowns: { loading: false, ...action.payload } };
        case types.FETCH_SCHEDULE_DROPDOWNS_FAILURE:
            return { ...state, dropdowns: { ...state.dropdowns, loading: false } };

        case types.SAVE_SHIFT_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, saving: true, conflictPreview: null } };
        case types.SAVE_SHIFT_SUCCESS:
        case types.SAVE_SHIFT_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, saving: false } };

        case types.SAVE_SHIFT_BULK_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, bulkSaving: true, bulkResult: null, conflictPreview: null } };
        case types.SAVE_SHIFT_BULK_SUCCESS:
            return { ...state, shiftForm: { ...state.shiftForm, bulkSaving: false, bulkResult: action.payload } };
        case types.SAVE_SHIFT_BULK_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, bulkSaving: false } };
        case types.CLEAR_BULK_RESULT:
            return { ...state, shiftForm: { ...state.shiftForm, bulkResult: null } };

        case types.DELETE_SHIFT_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, deleting: true } };
        case types.DELETE_SHIFT_SUCCESS:
        case types.DELETE_SHIFT_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, deleting: false } };

        case types.UPDATE_SHIFT_GROUP_REQUEST:
        case types.DELETE_SHIFT_GROUP_REQUEST:
        case types.SWAP_SHIFT_GROUP_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, groupActionLoading: true, conflictPreview: null } };
        case types.UPDATE_SHIFT_GROUP_SUCCESS:
        case types.UPDATE_SHIFT_GROUP_FAILURE:
        case types.DELETE_SHIFT_GROUP_SUCCESS:
        case types.DELETE_SHIFT_GROUP_FAILURE:
        case types.SWAP_SHIFT_GROUP_SUCCESS:
        case types.SWAP_SHIFT_GROUP_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, groupActionLoading: false } };

        case types.SWAP_SHIFT_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, saving: true, conflictPreview: null } };
        case types.SWAP_SHIFT_SUCCESS:
        case types.SWAP_SHIFT_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, saving: false } };

        case types.SET_CONFLICT_PREVIEW:
            return { ...state, shiftForm: { ...state.shiftForm, conflictPreview: action.payload } };
        case types.CLEAR_CONFLICT_PREVIEW:
            return { ...state, shiftForm: { ...state.shiftForm, conflictPreview: null } };

        case types.UPDATE_SHIFT_NOTES_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, updatingNotes: true } };
        case types.UPDATE_SHIFT_NOTES_SUCCESS:
        case types.UPDATE_SHIFT_NOTES_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, updatingNotes: false } };

        case types.FETCH_SHIFT_PRIVILEGES_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, privilegesLoading: true, privileges: [] } };
        case types.FETCH_SHIFT_PRIVILEGES_SUCCESS:
            return { ...state, shiftForm: { ...state.shiftForm, privilegesLoading: false, privileges: action.payload } };
        case types.FETCH_SHIFT_PRIVILEGES_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, privilegesLoading: false } };

        case types.FETCH_RAD_ASSOCIATED_SITES_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, radAssociatedSitesLoading: true, radAssociatedSites: [] } };
        case types.FETCH_RAD_ASSOCIATED_SITES_SUCCESS:
            return { ...state, shiftForm: { ...state.shiftForm, radAssociatedSitesLoading: false, radAssociatedSites: action.payload } };
        case types.FETCH_RAD_ASSOCIATED_SITES_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, radAssociatedSitesLoading: false } };
        case types.CLEAR_RAD_ASSOCIATED_SITES:
            return { ...state, shiftForm: { ...state.shiftForm, radAssociatedSites: [], radAssociatedSitesLoading: false, radAssociatedSitesByRad: {} } };

        case types.FETCH_RADS_ASSOCIATED_SITES_REQUEST:
            return { ...state, shiftForm: { ...state.shiftForm, radsAssociatedSitesLoading: true, radAssociatedSitesByRad: {} } };
        case types.FETCH_RADS_ASSOCIATED_SITES_SUCCESS:
            return { ...state, shiftForm: { ...state.shiftForm, radsAssociatedSitesLoading: false, radAssociatedSitesByRad: action.payload } };
        case types.FETCH_RADS_ASSOCIATED_SITES_FAILURE:
            return { ...state, shiftForm: { ...state.shiftForm, radsAssociatedSitesLoading: false } };

        default:
            return state;
    }
};

export default scheduleViewerReducer;
